import {
  BASE_API_URL,
  post,
} from '@/utils/http'

export * from './common'
export const queryOpenBatchEnrollListUrl = `${BASE_API_URL}/bm/queryBmxxCartList`
export const queryOpenBatchEnrollList = (...args) => {
  return post(queryOpenBatchEnrollListUrl, ...args)
}

export const queryOpenBatchNjrtsEnrollListUrl = `${BASE_API_URL}/bm/queryNjrtsBmxxCartList`
export const queryOpenBatchNjrtsEnrollList = (...args) => {
  return post(queryOpenBatchNjrtsEnrollListUrl, ...args)
}

// 撤销报名详情
export const cancelEnrollUrl = `${BASE_API_URL}/bm/cancelDzKsBmxx`
export const cancelEnroll = (...args) => {
  return post(cancelEnrollUrl, ...args)
}

// 查看报名须知
export const queryNoticeUrl = `${BASE_API_URL}/bm/queryBmxz`
export const queryNotice = (...args) => {
  return post(queryNoticeUrl, ...args)
}

// 查看报名详情
export const queryEnrollDetailUrl = `${BASE_API_URL}/bm/queryDzKsBmxxDetail`
export const queryEnrollDetail = (...args) => {
  return post(queryEnrollDetailUrl, ...args)
}

// 提交
export const submitEnrollUrl = `${BASE_API_URL}/bm/submit`
export const submitEnroll = (...args) => {
  return post(submitEnrollUrl, ...args)
}

// 校验基本必填信息
export const checkBaseRequireInfoUrl = `${BASE_API_URL}/bm/checkKsJbxxReady`
export const checkBaseRequire = (...args) => {
  return post(checkBaseRequireInfoUrl, ...args)
}

// 保存考生基本消息
export const insertBaseInfoUrl = `${BASE_API_URL}/bm/insertOrUpdateKsxx`
export const insertBaseInfo = (...args) => {
  return post(insertBaseInfoUrl, ...args)
}

// 保存家庭成员
export const insertOrUpdateFamilyUrl = `${BASE_API_URL}/bm/insertOrUpdateKsJtcy`
export const insertOrUpdateFamily = (...args) => {
  return post(insertOrUpdateFamilyUrl, ...args)
}

// 删除家庭成员
export const deleteFamilyUrl = `${BASE_API_URL}/bm/deleteKsJtcy`
export const deleteFamily = (...args) => {
  return post(deleteFamilyUrl, ...args)
}

// 查询家庭成员
export const queryFamilyUrl = `${BASE_API_URL}/bm/queryKsJtcyList`
export const queryFamily = (...args) => {
  return post(queryFamilyUrl, ...args)
}

// 上传附件
export const uploadAttachmentUrl = `${BASE_API_URL}/bm/uploadAttachment`
export const uploadAttachment = (...args) => {
  return post(uploadAttachmentUrl, ...args)
}

// 保存学习经历
export const insertOrUpdateStudyUrl = `${BASE_API_URL}/bm/insertOrUpdateKsXxjl`
export const insertOrUpdateStudy = (...args) => {
  return post(insertOrUpdateStudyUrl, ...args)
}

// 删除学习经历
export const deleteStudyUrl = `${BASE_API_URL}/bm/deleteKsXxjl`
export const deleteStudy = (...args) => {
  return post(deleteStudyUrl, ...args)
}

// 查询学习经历
export const queryStudyUrl = `${BASE_API_URL}/bm/queryKsXxjlList`
export const queryStudy = (...args) => {
  return post(queryStudyUrl, ...args)
}

// 上传照片
export const uploadEnrollPhotoUrl = `${BASE_API_URL}/bm/uploadPhoto`
export const uploadEnrollPhoto = (...args) => {
  return post(uploadEnrollPhotoUrl, ...args)
}

// 查询志愿
export const queryVolunteerUrl = `${BASE_API_URL}/bm/queryZyList`
export const queryVolunteer = (...args) => {
  return post(queryVolunteerUrl, ...args)
}

// 查询可报考专业志愿数
export const queryVolunteerEnrollNumberUrl = `${BASE_API_URL}/bm/queryKbzyzys`
export const queryVolunteerEnrollNumber = (...args) => {
  return post(queryVolunteerEnrollNumberUrl, ...args)
}

// 保存志愿信息
export const updateVolunteerUrl = `${BASE_API_URL}/bm/updateKsZyxx`
export const updateVolunteer = (...args) => {
  return post(updateVolunteerUrl, ...args)
}

// 查询科类
export const queryCategoriesUrl = `${BASE_API_URL}/bm/queryKlList`
export const queryCategories = (...args) => {
  return post(queryCategoriesUrl, ...args)
}

// 下载报名表
export const downloadEnrollTableUrl = `${BASE_API_URL}/bm/downloadBmb`
export const downloadEnrollTable = (...args) => {
  return post(downloadEnrollTableUrl, ...args)
}

// 保存附件
export const saveAttachmentUrl = `${BASE_API_URL}/bm/saveAttachment`
export const saveAttachment = (...args) => {
  return post(saveAttachmentUrl, ...args)
}

// 我的报名信息
export const queryMyEnrollListUrl = `${BASE_API_URL}/bm/queryBmxxList`
export const queryMyEnrollList = (...args) => {
  return post(queryMyEnrollListUrl, ...args)
}

export const downloadExamBookUrl = `${BASE_API_URL}/pk/downloadZkz`
export const downloadExamBook = (...args) => {
  return post(downloadExamBookUrl, ...args)
}

// 查询排考结果
export const queryExamConfigUrl = `${BASE_API_URL}/pk/queryKsPkList`
export const queryExamConfig = (...args) => {
  return post(queryExamConfigUrl, ...args)
}

// 查询单招成绩
export const queryGardeUrl = `${BASE_API_URL}/cj/queryKsCjList`
export const queryGarde = (...args) => {
  return post(queryGardeUrl, ...args)
}

// 查询录取结果
export const queryEnrollResultUrl = `${BASE_API_URL}/lq/queryKsLqList`
export const queryEnrollResult = (...args) => {
  return post(queryEnrollResultUrl, ...args)
}

// 查询录取结果是否显示投档总成绩
export const queryEnrollResultTdzcjSwitchUrl = `${BASE_API_URL}/lq/querySfxsTdcj`
export const queryEnrollResultTdzcjSwitch = (...args) => {
  return post(queryEnrollResultTdzcjSwitchUrl, ...args)
}

// 查询录取结果
export const queryNjrtsEnrollResultUrl = `${BASE_API_URL}/lq/queryKsNtLqList`
export const queryNjrtsEnrollResult = (...args) => {
  return post(queryNjrtsEnrollResultUrl, ...args)
}

// 查询拟录取结果
export const queryPrepareEnrollResultUrl = `${BASE_API_URL}/lq/queryKsNlqList`
export const queryPrepareEnrollResult = (...args) => {
  return post(queryPrepareEnrollResultUrl, ...args)
}

// 查看缴费信息
export const queryPayInfoUrl = `${BASE_API_URL}/jf/queryDzKsJfxxCartList`
export const queryPayInfo = (...args) => {
  return post(queryPayInfoUrl, ...args)
}

// 查看已缴费信息
export const queryHasFinishPayListUrl = `${BASE_API_URL}/jf/queryDzKsJfxxList`
export const queryHasFinishPayList = (...args) => {
  return post(queryHasFinishPayListUrl, ...args)
}

// 查看缴费详情
export const queryPayOrderInfoUrl = `${BASE_API_URL}/jf/queryDzKsJfxqList`
export const queryPayOrderInfo = (...args) => {
  return post(queryPayOrderInfoUrl, ...args)
}

// 微信下单
export const doOrderUrl = `${BASE_API_URL}/jf/order`
export const doOrder = (...args) => {
  return post(doOrderUrl, ...args)
}

export const queryPayNoticeUrl = `${BASE_API_URL}/jf/queryJfxz`
export const queryPayNotice = (...args) => {
  return post(queryPayNoticeUrl, ...args)
}

export const updateEnrollTypeUrl = `${BASE_API_URL}/bm/updateKsDzlbdm`
export const updateEnrollType = (...args) => {
  return post(updateEnrollTypeUrl, ...args)
}

export const queryCurrentEnrollBatchEnrollTypeUrl = `${BASE_API_URL}/bm/queryKsDzlbdm`
export const queryCurrentEnrollBatchEnrollType = (...args) => {
  return post(queryCurrentEnrollBatchEnrollTypeUrl, ...args)
}

export const queryBatchSingleEnrollConfigUrl = `${BASE_API_URL}/bm/queryDzDzlbConfig`
export const queryBatchSingleEnrollConfig = (...args) => {
  return post(queryBatchSingleEnrollConfigUrl, ...args)
}

export const queryUserPayListUrl = `${BASE_API_URL}/gr/queryKsJfxxList`
export const queryUserPayList = (...args) => {
  return post(queryUserPayListUrl, ...args)
}

export const queryUserEnrollInfoListUrl = `${BASE_API_URL}/gr/queryKsBmxxList`
export const queryUserEnrollInfoList = (...args) => {
  return post(queryUserEnrollInfoListUrl, ...args)
}

export const queryZybgInfoUrl = `${BASE_API_URL}/zybg/queryZybgInfo`
export const queryZybgInfo = (...args) => {
  return post(queryZybgInfoUrl, ...args)
}

export const submitZybgInfoUrl = `${BASE_API_URL}/zybg/submit`
export const submitZybgInfo = (...args) => {
  return post(submitZybgInfoUrl, ...args)
}

export const cancelZybgInfoUrl = `${BASE_API_URL}/zybg/cancel`
export const cancelZybgInfo = (...args) => {
  return post(cancelZybgInfoUrl, ...args)
}
